<template>
  <div class="navbar-container d-flex content align-items-center">

    <!-- Nav Menu Toggler -->
    <ul class="nav navbar-nav d-xl-none">
      <li class="nav-item">
        <b-link
          class="nav-link"
          @click="toggleVerticalMenuActive"
        >
          <feather-icon
            icon="MenuIcon"
            size="21"
          />
        </b-link>
      </li>
    </ul>

    <div class="nav align-items-center">
      <b-avatar
            size="40"
            variant="light-primary"
            badge
            :src="$store.getters['oauth/getActiveUser'].avatar"
            class="badge-minimal"
            badge-variant="success"
      />
      <div class="d-sm-flex d-none align-items-start ml-2 flex-column">
        <p class="user-name font-weight-bolder mb-0">
          {{ $store.getters['oauth/getActiveUser'].name }}
        </p>
        <!-- <span style="font-size: smaller;">Admin</span> -->
      </div>
    </div>
    <div class="nav align-items-center ml-auto ">
      <b-button
        v-ripple.400="'rgba(40, 199, 111, 0.15)'"
        variant="flat-secondary"
        @click="$store.commit('app/CHANGE_DISPLAY')"
      >
        <feather-icon
            size="16"
            icon="TvIcon"
            class="mr-50"
          />
        <span>Portal</span>
      </b-button>
    </div>
    <div class="nav align-items-center mr-2">
      <b-button
        v-ripple.400="'rgba(40, 199, 111, 0.15)'"
        variant="flat-danger"
        v-tracker="'button:logout'"
        @click="logout"
      >
        <feather-icon
          size="16"
          icon="LogOutIcon"
          class="mr-50"
          
        />
        <span>Logout</span>
      </b-button>
    </div>
    
  </div>
</template>

<script>
import {
  BLink, BNavbarNav, BNavItemDropdown, BDropdownItem, BDropdownDivider, BAvatar, BButton
} from 'bootstrap-vue'
import DarkToggler from '@core/layouts/components/app-navbar/components/DarkToggler.vue'
import Ripple from 'vue-ripple-directive'

export default {
  components: {
    BLink,
    BNavbarNav,
    BNavItemDropdown,
    BDropdownItem,
    BDropdownDivider,
    BAvatar,
    BButton,

    // Navbar Components
    DarkToggler,
  },
  props: {
    toggleVerticalMenuActive: {
      type: Function,
      default: () => {},
    },
  },
  directives: {
    Ripple,
  },
  methods: {
    logout() {
      this.$store.commit('oauth/clearToken');
      
      localStorage.removeItem('token');
      localStorage.removeItem('coin');
      localStorage.removeItem('role');
      
      this.$http.defaults.headers.common['Authorization'] = '';
      
      document.cookie.split(";").forEach(cookie => {
        const eqPos = cookie.indexOf("=");
        const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
        document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/";
      });
      
      this.$router.push({ name: 'login' });
    },
  }
}
</script>
